<template>
  <div style="min-width: 97%;">
  <div class="header-main ">
  <div class="hm-left ">
    <div>
      <div class="bread-crumb"></div>
      <div class="header-main__title-wrap"><h1 class="header-main__title">{{ title }} </h1>
      <div class="header-main__review"></div>
      </div>
      </div>
    </div>
    
    <div class="hm-right">
      <div v-if="$store.state.user.id === 162">
        
      <div class="btn-wrapper btn-wrapper_group new megamenu">
        
        <transition name="fade-menu">

        <div class="allitem" v-if="isVisibleMegamenu">
        <router-link to="/tasksto" class="btn_ms m0 btn grens">
          <div class="">Задачи СТО</div>
        </router-link>
        
        <router-link to="/sto" class="btn_ms m0 btn grens">
          <div class="">Посты СТО</div>
        </router-link>     
        
        <router-link to="/chats" class="btn_ms m0 btn currentorange">
          <div class="chats-link">
            Чаты
            <span v-if="unreadChatsCount > 0" class="unread-badge">{{ unreadChatsCount }}</span>
          </div>
        </router-link>          
        <router-link to="/bonus" class="btn_ms btn currentorange">
            <div class="">Бонусы</div>
          </router-link>          
        <router-link to="/info_bonus" class="btn_ms btn currentorange">
            <div class="">Инфо Бонусы</div>
          </router-link>
       <router-link to="/" class="btn_ms btn currentorange">
          <div class="">Товары</div>
        </router-link>   
        
        <router-link to="/alltask" class="btn_ms m0 btn btntask">
          <div class="">Задачи</div>
        </router-link>

        <router-link to="/status-matrix" class="btn_ms m0 btn">
          <div class="">Матрица статусов</div>
        </router-link>

        <router-link to="/team-status" class="btn_ms m0 btn">
          <div class="">Статусы менеджеров</div>
        </router-link>

        <router-link to="/users-activity" class="btn_ms m0 btn">
          <div class="">Активность за день</div>
        </router-link>

        <router-link to="/bot-dialog-analytics" class="btn_ms m0 btn">
          <div class="">Диалоги бота</div>
        </router-link>

        <router-link to="/reviews-response" class="btn_ms m0 btn">
          <div class="">Ответы на отзывы</div>
        </router-link>

        <router-link v-if="isRukovodstvoRole" to="/kassa-after-redirect" class="btn_ms m0 btn">
          <div class="">Касса после доставки</div>
        </router-link>

        <router-link v-if="isRukovodstvoRole" to="/kassa-30-days" class="btn_ms m0 btn">
          <div class="">Кассы за 30 дней</div>
        </router-link>

        <router-link to="/karvata-dovoz" class="btn_ms m0 btn">
          <div class="">Довоз с Карваты</div>
        </router-link>

        </div>

      </transition>


        <button class="btn_md custmenu" @click="openMegamenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
            <path d="M4 18H10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 12L16 12" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 6L20 6" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Меню
        </button>

              <div v-if="!hideOrderButton" class="btn_md m0 btn" :class="{ disabled: hasSavedOrders }"
    :disabled="hasSavedOrders">
          <div class="btn-content btn-content_icon btn-content_new" @click="newOrder">Новый заказ</div>

        </div>  


        
       

      </div>
        



      </div>

      <div v-else>

      <div class="btn-wrapper btn-wrapper_group new">
        <router-link to="/tasksto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
          <div class="">Задачи</div>
        </router-link>      
        
        <router-link to="/timesellers" class="btn_ms m0 btn" v-if="$store.state.user.id === 307">
          <div >Время работы продавцов</div>
        </router-link> 

        <router-link to="/bonus" class="btn_ms btn ">
            <div class="">Бонусы</div>
          </router-link>
        <router-link to="/alltask" class="btn_ms m0 btn btntask">
          <div class="">Задачи</div>
        </router-link>
        <router-link to="/sto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
          <div class="">Посты</div>
        </router-link>
       <router-link to="/" class="btn_ms btn">
          <div class="">Товары</div>
        </router-link>
        <router-link to="/team-status" class="btn_ms m0 btn">
          <div class="">Статусы менеджеров</div>
        </router-link>
        <router-link to="/users-activity" class="btn_ms m0 btn">
          <div class="">Активность за день</div>
        </router-link>
        <router-link to="/bot-dialog-analytics" class="btn_ms m0 btn">
          <div class="">Диалоги бота</div>
        </router-link>
      <div v-if="!hideOrderButton" class="btn_md m0 btn" :class="{ disabled: hasSavedOrders }"
    :disabled="hasSavedOrders">
          <div class="btn-content btn-content_icon btn-content_new" @click="newOrder">Новый заказ</div>
        
        </div>  

      </div>
      </div>


    </div>

  </div>

  </div>
  </template>

  <script scoped>

import { mapGetters } from 'vuex';

export default {
  name: 'HeaderMain',
  data() {
    return {
      isVisibleMegamenu: false,
      hasSavedOrders: false
    };
  },
  props: {
    hideOrderButton: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Заказы',
    }
  },
  computed: {
    ...mapGetters('chatModule', ['unreadChatsCount']),
    isRukovodstvoRole() {
      const u = this.$store.state.user;
      if (!u) return false;
      return String(u.role || '').toLowerCase().includes('руководство');
    }
  },
  methods: {
  openMegamenu(){
      this.isVisibleMegamenu = !this.isVisibleMegamenu;
    },
  }
};
</script>


<style scoped>


.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu {
  background: #005eeb;
    border: none;
    color: #fff;
    border-radius: 6px;
    transition: 0.3s;
    margin-right: 15px;
}
.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu:hover {
  background: #1170ff;
}

.btn-wrapper.btn-wrapper_group.new.megamenu {
  display: flex;
  align-items: center;
  justify-content: center;
}


.btn.grens {
  background: #1abc9c !important;
}

.megamenu {
  position: relative;
}
.megamenu .allitem {
  display: flex;
  width: 300px;
  position: absolute;
  flex-wrap: wrap;
  top: 60px;
  z-index: 10;
  padding: 20px;
  background: #f4f6f8;
  padding-top: 5px;
}

 .megamenu .allitem .btn {
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
 }

 .megamenu .currentorange {
  background: #fea530 !important;
 }

.chats-link {
  position: relative;
  display: inline-block;
}

.unread-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4757;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}


 .fade-menu-enter-active,
.fade-menu-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-menu-enter-from,
.fade-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-menu-enter-to,
.fade-menu-leave-from {
  opacity: 1;
  transform: translateY(0);
}



.header-main {
    display: flex;
    empty-cells: hide;
    padding: 0px 0 24px;
    justify-content: space-between;
    padding: 32px 0 24px;
}

.header-main .hm-left,
.header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}
.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
  }


  .btn_ms { 
    margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
  }


  .btn_md {
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
  }

</style>